<template>
  <!-- Main  -->
  <section class="hero-bg h-auto">
    <section class="h-screen" id="main">
      <div
        class="flex flex-col lg:flex-row justify-center items-center pt-20 md:pt-40 lg:pt-28 2xl:pt-40 font-oxanium gap-10"
      >
        <div>
          <img
            v-motion-pop-visible
            src="../assets/mrchocolate-logo.png"
            class="max-w-[300px] md:max-w-[600px] lg:max-w-[500px] 2xl:max-w-[700px]"
          />
        </div>
        <div class="flex flex-col justify-center items-center gap-5">
          <div
            v-motion-pop-visible
            class="flex flex-col text-white uppercase text-3xl md:text-7xl font-nunito font-black"
          >
            <div>Spin Together,</div>
            <div>Win Together!</div>
          </div>
          <div
            v-motion-pop-visible
            class="flex flex-col md:flex-row gap-4 mt-4 font-lato"
          >
            <a href="https://roobet.com/?ref=mrchocolate" target="_blank">
              <button
                class="text-black font-bold bg-gradient-to-br from-white via-red-100 to-white font-base py-5 px-[30px] relative uppercase rounded-xl transition hover:scale-105 ease-in-out duration-200"
              >
                REGISTER ON ROOBET.COM
              </button>
            </a>
            <a href="https://kick.com/mrchocolateslot" target="_blank">
              <button
                class="text-white font-bold bg-gradient-to-br from-black via-gray-700 to-black font-base py-[22px] px-[30px] md:px-[36px] relative uppercase rounded-xl transition hover:scale-105 ease-in-out duration-200"
              >
                WATCH LIVE AT KICK.COM
              </button>
            </a>
          </div>
        </div>
      </div>
    </section>
    <!-- Raffle Section -->
    <section
      class="h-auto px-6 md:px-6 lg:px-36 2xl:px-[340px] pt-80 md:pt-20 lg:pt-40"
      id="promotions"
    >
      <div class="flex flex-col justify-center items-center font-nunito">
        <p
          v-motion-pop-visible
          class="text-white text-center font-black bg-gradient-to-b from-[#FFFFFF] via-[#E66D17] to-[#EF4737] bg-clip-text text-transparent text-4xl uppercase"
        >
          Promotions
        </p>
      </div>
      <div class="flex justify-center items-center gap-6">
        <div
          v-motion-pop-visible
          class="hidden md:block h-[700px] w-[1200px] md:h-[500px] promotion-frame-bg -mt-10 md:mt-0"
        >
          <div class="flex flex-row justify-center lg:justify-end items-center">
            <div
              class="flex flex-row items-start md:ml-14 lg:ml-20 gap-2 lg:w-[50%] mt-14 md:mt-10 lg:mt-24"
            >
              <div class="flex flex-col gap-1 font-nunito mt-24 lg:-ml-32">
                <span
                  class="text-xl md:text-xl lg:text-2xl font-black text-[#FFCE00] text-center md:text-left uppercase"
                  >Use Code</span
                >
                <span
                  class="text-4xl md:text-4xl lg:text-6xl font-black text-white text-center md:text-left uppercase"
                  >MRCHOCOLATE</span
                >
                <span
                  class="text-xl md:text-xl lg:text-2xl font-black text-[#FFCE00] text-center md:text-left uppercase"
                  >ON ROOBET.COM</span
                >
                <a href="https://roobet.com/?ref=mrchocolate" target="_blank">
                  <button
                    class="text-white font-bold bg-gradient-to-br from-black via-gray-700 to-black font-base py-[16px] px-[30px] md:px-[20px] relative uppercase rounded-xl transition hover:scale-105 ease-in-out duration-200"
                  >
                    REGISTER ON ROOBET.COM NOW
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          v-motion-pop-visible
          class="md:hidden h-[500px] w-[1200px] md:h-[500px] promotion-frame-mobile-bg container mx-auto mt-14"
        >
          <div class="flex flex-row justify-center md:justify-start items-center">
            <div
              class="flex flex-col items-start md:ml-14 lg:ml-20 gap-2 mt-14 md:mt-10 lg:mt-24"
            >
              <div class="flex flex-col gap-1 font-nunito mt-10 mx-4">
                <span
                  class="text-xl md:text-xl lg:text-2xl font-black text-[#FFCE00] text-center md:text-left uppercase"
                  >Use Code</span
                >
                <span
                  class="text-4xl md:text-4xl lg:text-6xl font-black text-white text-center md:text-left uppercase"
                  >MRCHOCOLATE</span
                >
                <span
                  class="text-xl md:text-xl lg:text-2xl font-black text-[#FFCE00] text-center md:text-left uppercase"
                  >ON ROOBET.COM</span
                >
                <a href="https://roobet.com/?ref=mrchocolate" target="_blank">
                  <button
                    class="text-white font-bold bg-gradient-to-br from-black via-gray-700 to-black font-base py-[16px] px-[30px] md:px-[20px] relative uppercase rounded-xl transition hover:scale-105 ease-in-out duration-200"
                  >
                    REGISTER ON ROOBET.COM NOW
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>

  <!-- Socials Section -->
  <section
    class="h-auto px-6 md:px-6 lg:px-36 2xl:px-[340px] pt-4 lg:pt-40 pb-40 socials-bg"
    id="socials"
  >
    <div class="flex flex-col justify-center items-center font-nunito">
      <p
        v-motion-pop-visible
        class="text-white text-center font-black bg-gradient-to-b from-[#FFFFFF] via-[#E66D17] to-[#EF4737] bg-clip-text text-transparent text-3xl md:text-4xl uppercase"
      >
        FOLLOW MY <span class="text-[#FFB700]">SOCIALS</span>
      </p>
    </div>
    <div
      class="flex flex-wrap justify-center items-center gap-8 md:gap-12 lg:gap-14 mt-10"
      style="font-family: Oxanium, sans-serif"
    >
      <a href="https://kick.com/mrchocolateslot" target="_blank">
        <div v-motion-pop-visible class="flex flex-col justify-center items-center">
          <img src="../assets/kick.png" class="w-[60px]" alt="" />
        </div>
      </a>
      <a href="https://www.youtube.com/@MrChocolateslots" target="_blank">
        <div v-motion-pop-visible class="flex flex-col justify-center items-center">
          <img src="../assets/youtube.png" class="w-[60px]" alt="" />
        </div>
      </a>
      <a href="https://www.instagram.com/mrchocolateslots" target="_blank">
        <div v-motion-pop-visible class="flex flex-col justify-center items-center">
          <img src="../assets/insta.png" class="w-[60px]" alt="" />
        </div>
      </a>
      <a href="https://twitter.com/MrChocolateslot" target="_blank">
        <div v-motion-pop-visible class="flex flex-col justify-center items-center">
          <img src="../assets/twitter.png" class="w-[60px]" alt="" />
        </div>
      </a>
      <!-- <a href="http://discord.gg/mrchocolateslot" target="_blank">
        <div v-motion-pop-visible class="flex flex-col justify-center items-center">
          <img src="../assets/discord.png" class="w-[60px]" alt="" />
        </div>
      </a> -->
    </div>
  </section>

  <section
    class="h-auto px-6 md:px-6 lg:px-36 2xl:px-[340px] py-20 lg:py-20 leaderboard-bg"
    id="leaderboards"
  >
    <div class="flex flex-col justify-center items-center font-nunito mt-14">
      <p
        v-motion-pop-visible
        class="text-white text-center font-black bg-gradient-to-b from-[#FFFFFF] via-[#E66D17] to-[#EF4737] bg-clip-text text-transparent text-3xl md:text-4xl uppercase tracking-widest"
      >
        <span class="text-[#FFB700]">{{ getFormattedTotalPrize() }}</span> Bi-Weekly
        <span class="text-[#FFB700]">MRCHOCOLATESLOT</span><br />
        Leaderboard
      </p>
    </div>
    <!-- <div class="flex justify-center items-center flex-col md:flex-row gap-4 mt-10 px-8 font-lato">
            <button v-motion-slide-visible-right :disabled="loading == true" @click="activeTab = 'roobet';" :class="{'bg-[#E64435] border-[#E64435]': activeTab == 'roobet'}" class="text-white font-extrabold shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#E64435] border hover:border-[#E64435] hover:text-white font-base py-3 px-8 md:px-10 relative uppercase rounded-xl">
              <img src="../assets/roobet-logo.png" class="w-[150px]">
            </button>
            <button v-motion-slide-visible-left :disabled="loading == true" @click="activeTab = 'packdraw';" :class="{'bg-[#E64435] border-[#E64435]': activeTab == 'packdraw'}" class="text-white font-extrabold shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#E64435] border hover:border-[#E64435] hover:text-white font-base py-[11px] px-8 md:px-9 relative uppercase rounded-xl">
              <img src="../assets/packdraw-logo.png" class="w-[150px]">
            </button>
        </div> -->
    <div>
      <!-- Leaderboard Section -->
      <section
        :class="loading == true ? 'h-screen' : 'h-auto'"
        class="container mx-auto"
        id="leaderboard"
      >
        <div class="flex justify-center">
          <div class="flex flex-col justify-center items-center p-8 rounded-3xl">
            <div
              v-if="loading == true"
              class="text-center text-white text-2xl md:text-4xl mt-14 font-black font-lato"
            >
              Loading Leaderboard...
            </div>
            <div v-if="loading == false" class="hidden md:block">
              <div
                class="flex flex-row justify-center items-center gap-6 lg:gap-44 mt-20 font-lato"
              >
                <div v-motion-pop-visible class="flex flex-col items-center w-60">
                  <div
                    class="bg-black/50 backdrop-blur-2xl shadow-[#A26446] shadow-2xl w-full lg:w-[300px] h-[340px] rounded-3xl"
                  >
                    <div class="flex flex-col justify-center items-center">
                      <div class="flex flex-col justify-between items-center -mt-[75px]">
                        <div class="mb-5">
                          <img src="../assets/2nd.png" class="w-[220px]" />
                        </div>
                        <div>
                          <span class="text-[#FFB700] font-bold text-xl">{{
                            top3.length > 0 && top3[1] != undefined
                              ? maskString(top3[1].username)
                              : "---"
                          }}</span>
                        </div>
                      </div>
                      <div class="flex flex-col text-center w-full gap-1">
                        <span class="text-white font-extrabold text-[42px] uppercase"
                          >$
                          {{
                            top3.length > 0 && top3[1] != undefined
                              ? top3[1].wagered
                              : "---"
                          }}</span
                        >
                        <span class="text-white font-bold text-sm uppercase"
                          >Wagered</span
                        >
                      </div>
                      <div
                        class="flex flex-col text-center mt-6 py-4 bg-black border-2 border-[#E64435] px-8 rounded-md"
                      >
                        <span
                          class="text-white font-black font-montserrat text-4xl uppercase"
                          >{{ getRewardValue(1) }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div v-motion-pop-visible class="flex flex-col items-center w-60">
                  <div
                    class="bg-black/50 backdrop-blur-2xl shadow-[#A26446] shadow-2xl w-full lg:w-[300px] h-[340px] rounded-3xl"
                  >
                    <div class="flex flex-col justify-center items-center">
                      <div class="flex flex-col justify-between items-center -mt-[75px]">
                        <div class="mb-5">
                          <img src="../assets/1st.png" class="w-[220px]" />
                        </div>
                        <div>
                          <span class="text-[#FFB700] font-bold text-xl">{{
                            top3.length > 0 && top3[0] != undefined
                              ? maskString(top3[0].username)
                              : "---"
                          }}</span>
                        </div>
                      </div>
                      <div class="flex flex-col text-center w-full gap-1">
                        <span class="text-white font-extrabold text-[42px] uppercase"
                          >$
                          {{
                            top3.length > 0 && top3[0] != undefined
                              ? top3[0].wagered
                              : "---"
                          }}</span
                        >
                        <span class="text-white font-bold text-sm uppercase"
                          >Wagered</span
                        >
                      </div>
                      <div
                        class="flex flex-col text-center mt-6 py-4 bg-black border-2 border-[#E64435] px-8 rounded-md"
                      >
                        <span
                          class="text-white font-black font-montserrat text-4xl uppercase"
                          >{{ getRewardValue(0) }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div v-motion-pop-visible class="flex flex-col items-center w-60">
                  <div
                    class="bg-black/50 backdrop-blur-2xl shadow-[#A26446] shadow-2xl w-full lg:w-[300px] h-[340px] rounded-3xl"
                  >
                    <div class="flex flex-col justify-center items-center">
                      <div class="flex flex-col justify-between items-center -mt-[75px]">
                        <div class="mb-5">
                          <img src="../assets/3rd.png" class="w-[220px]" />
                        </div>
                        <div>
                          <span class="text-[#FFB700] font-bold text-xl">{{
                            top3.length > 0 && top3[2] != undefined
                              ? maskString(top3[2].username)
                              : "---"
                          }}</span>
                        </div>
                      </div>
                      <div class="flex flex-col text-center w-full gap-1">
                        <span class="text-white font-extrabold text-[42px] uppercase"
                          >$
                          {{
                            top3.length > 0 && top3[2] != undefined
                              ? top3[2].wagered
                              : "---"
                          }}</span
                        >
                        <span class="text-white font-bold text-sm uppercase"
                          >Wagered</span
                        >
                      </div>
                      <div
                        class="flex flex-col text-center mt-6 py-4 bg-black border-2 border-[#E64435] px-8 rounded-md"
                      >
                        <span
                          class="text-white font-black font-montserrat text-4xl uppercase"
                          >{{ getRewardValue(2) }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p
                v-motion-pop-visible
                class="text-white text-center font-black bg-clip-text text-transparent text-3xl md:text-4xl uppercase font-nunito mt-16 tracking-widest"
              >
                <span class="text-[#FFB700]">New</span> Leaderboard Starts In
              </p>
              <div v-motion-pop-visible class="mt-10">
                <div class="flex flex-row justify-evenly items-center">
                  <div class="flex flex-col items-center gap-4">
                    <div
                      class="flex flex-row gap-4"
                      style="font-family: Oxanium, sans-serif"
                    >
                      <div
                        class="bg-[#000000] shadow-[#A26446] shadow-2xl rounded-full flex flex-col justify-center items-center w-[65px] md:w-[80px] md:h-[80px]"
                      >
                        <span
                          v-if="previousLeaderboard == false"
                          class="font-bold text-4xl text-white"
                          >{{ days }}</span
                        >
                        <span v-else class="font-bold text-4xl text-white">0</span>
                        <div v-if="loading == true" class="mb-2" role="status">
                          <svg
                            aria-hidden="true"
                            class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#EF4737]"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                        </div>
                        <span class="font-bold text-xs md:text-xs text-white uppercase"
                          >Days</span
                        >
                      </div>
                      <div
                        class="bg-[#000000] shadow-[#A26446] shadow-2xl rounded-full flex flex-col justify-center items-center w-[65px] md:w-[80px] md:h-[80px]"
                      >
                        <span
                          v-if="previousLeaderboard == false"
                          class="font-bold text-4xl text-white"
                          >{{ hours }}</span
                        >
                        <span v-else class="font-bold text-4xl text-white">0</span>
                        <div v-if="loading == true" class="mb-2" role="status">
                          <svg
                            aria-hidden="true"
                            class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#EF4737]"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                        </div>
                        <span class="font-bold text-xs md:text-xs text-white uppercase"
                          >Hours</span
                        >
                      </div>
                      <div
                        class="bg-[#000000] shadow-[#A26446] shadow-2xl rounded-full flex flex-col justify-center items-center w-[65px] md:w-[80px] md:h-[80px]"
                      >
                        <span
                          v-if="previousLeaderboard == false"
                          class="font-bold text-4xl text-white"
                          >{{ minutes }}</span
                        >
                        <span v-else class="font-bold text-4xl text-white">0</span>
                        <div v-if="loading == true" class="mb-2" role="status">
                          <svg
                            aria-hidden="true"
                            class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#EF4737]"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                        </div>
                        <span class="font-bold text-xs md:text-xs text-white uppercase"
                          >Minutes</span
                        >
                      </div>
                      <div
                        class="bg-[#000000] shadow-[#A26446] shadow-2xl rounded-full flex flex-col justify-center items-center w-[65px] md:w-[80px] md:h-[80px]"
                      >
                        <span
                          v-if="previousLeaderboard == false"
                          class="font-bold text-4xl text-white"
                          >{{ seconds }}</span
                        >
                        <span v-else class="font-bold text-4xl text-white">0</span>
                        <div v-if="loading == true" class="mb-2" role="status">
                          <svg
                            aria-hidden="true"
                            class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#EF4737]"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                        </div>
                        <span class="font-bold text-xs md:text-xs text-white uppercase"
                          >Seconds</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="flex justify-center items-center flex-col md:flex-row gap-4 mt-20 px-8 font-lato"
              >
                <button
                  v-motion-slide-visible-right
                  :disabled="loading == true"
                  @click="
                    previousLeaderboard = false;
                    changeLeaderboard();
                  "
                  :class="{
                    'bg-[#FE0000] border-[#FE0000]': previousLeaderboard == false,
                  }"
                  class="text-white font-extrabold shadow-[#A26446] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#FE0000] hover:border-[#FE0000] hover:text-white font-base py-4 px-8 md:px-10 relative uppercase rounded-xl"
                >
                  Current Leaderboard
                </button>
                <button
                  v-motion-slide-visible-left
                  :disabled="loading == true"
                  @click="
                    previousLeaderboard = true;
                    changeLeaderboard();
                  "
                  :class="{
                    'bg-[#FE0000] border-[#FE0000]': previousLeaderboard == true,
                  }"
                  class="text-white font-extrabold shadow-[#A26446] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#FE0000] hover:border-[#FE0000] hover:text-white font-base py-4 px-8 md:px-9 relative uppercase rounded-xl"
                >
                  Previous Leaderboard
                </button>
              </div>

              <div
                class="flex flex-col justify-center bg-black/50 border border-[#A26446] rounded-xl shadow-[#A26446] shadow-2xl p-6 mt-12 mb:mb-24 font-lato"
              >
                <table class="w-full px-8">
                  <thead v-motion-slide-visible-bottom>
                    <tr>
                      <th
                        class="lg:pr-28 pb-8 pt-2 text-white text-[18px] md:text-xl font-bold text-left uppercase font-montserrat"
                      >
                        Rank
                      </th>
                      <th
                        class="lg:px-28 pb-8 pt-2 text-white text-[18px] md:text-xl font-bold text-center uppercase font-montserrat"
                      >
                        User
                      </th>
                      <th
                        class="lg:px-28 pb-8 pt-2 text-white text-[18px] md:text-xl font-bold text-center uppercase font-montserrat"
                      >
                        Amount
                      </th>
                      <th
                        class="lg:pl-28 pb-8 pt-2 text-white text-[18px] md:text-xl font-bold text-right uppercase font-montserrat"
                      >
                        Prize
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="top10.length == 0">
                      <td
                        colspan="4"
                        class="text-center text-white font-bold text-lg py-4 font-lato"
                      >
                        No data to show
                      </td>
                    </tr>
                    <tr
                      v-motion-slide-visible-bottom
                      v-for="(item, index) in top10"
                      :key="index"
                    >
                      <td
                        class="md:py-4 lg:py-3 pl-3 whitespace-nowrap text-[18px] text-white text-left rounded-l-lg"
                      >
                        {{ getOrdinalSuffix(index + 4) }}
                      </td>
                      <td
                        class="lg:py-3 whitespace-nowrap text-[18px] text-white text-center"
                      >
                        {{ maskString(item.username) }}
                      </td>
                      <td
                        class="lg:py-3 whitespace-nowrap text-[18px] text-white text-center"
                      >
                        $ {{ item.wagered }}
                      </td>
                      <td
                        class="lg:py-3 pr-3 whitespace-nowrap text-[18px] text-white text-right rounded-r-lg"
                      >
                        <span class="text-[#A26446]">
                          {{ getRewardValue(index + 3).charAt(0) }} </span
                        >{{ getRewardValue(index + 3).slice(1) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="loading == false" class="block md:hidden">
              <div
                class="flex justify-center items-center flex-col md:flex-row gap-4 mt-8 px-4 font-lato"
              >
                <button
                  v-motion-slide-visible-right
                  :disabled="loading == true"
                  @click="
                    previousLeaderboard = false;
                    changeLeaderboard();
                  "
                  :class="{
                    'bg-[#E64435] border-[#E64435]': previousLeaderboard == false,
                  }"
                  class="text-white font-extrabold shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#E64435] border border-white hover:border-[#E64435] hover:text-white font-base py-4 px-4 md:px-10 relative uppercase rounded-xl"
                >
                  Current Leaderboard
                </button>
                <button
                  v-motion-slide-visible-left
                  :disabled="loading == true"
                  @click="
                    previousLeaderboard = true;
                    changeLeaderboard();
                  "
                  :class="{
                    'bg-[#E64435] border-[#E64435]': previousLeaderboard == true,
                  }"
                  class="text-white font-extrabold shadow-[#D2410F] shadow-2xl bg-gradient-to-tl from-white/50 via-black/5 to-white/50 hover:bg-[#E64435] border border-white hover:border-[#E64435] hover:text-white font-base py-4 px-4 md:px-9 relative uppercase rounded-xl"
                >
                  Previous Leaderboard
                </button>
              </div>

              <div
                class="flex justify-center mt-8 md:mb-24 text-xl"
                style="font-family: Oxanium, sans-serif"
              >
                <table class="w-full">
                  <thead v-motion-slide-visible-bottom>
                    <tr>
                      <th
                        class="pr-4 text-white text-[15px] md:text-2xl font-semibold text-left"
                      >
                        Ranks
                      </th>
                      <th
                        class="px-4 text-white text-[15px] md:text-2xl font-semibold text-center"
                      >
                        User
                      </th>
                      <th
                        class="px-4 text-white text-[15px] md:text-2xl font-semibold text-center"
                      >
                        Amount
                      </th>
                      <th
                        class="pl-4 text-white text-[15px] md:text-2xl font-semibold text-right"
                      >
                        Prize
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="top13.length == 0">
                      <td colspan="4" class="text-center text-white font-bold py-4">
                        No data to show
                      </td>
                    </tr>
                    <tr
                      v-motion-slide-visible-bottom
                      v-for="(item, index) in top13"
                      :key="index"
                    >
                      <td
                        class="px-1 py-4 whitespace-nowrap text-[15px] text-white font-semibold text-left"
                      >
                        {{ getOrdinalSuffix(index + 1) }}
                      </td>
                      <td
                        class="px-1 whitespace-nowrap text-[14px] text-white font-semibold text-center"
                      >
                        {{ maskString(item.username) }}
                      </td>
                      <td
                        class="px-1 whitespace-nowrap text-[14px] text-white font-semibold text-center"
                      >
                        $ {{ item.wagered }}
                      </td>
                      <td
                        class="px-1 whitespace-nowrap text-[14px] text-white font-semibold text-right"
                      >
                        <span class="text-[#A26446]">
                          {{ getRewardValue(index).charAt(0) }} </span
                        >{{ getRewardValue(index).slice(1) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- <div v-if="loading == false" v-motion-pop-visible class="flex flex-col justify-center text-white mt-8 lg:mt-14 text-sm md:text-base uppercase font-semibold tracking-wider px-2 md:px-4 lg:px-20 2xl:ml-4 font-lato">
            <div>
              Your wagers on Roobet will count towards the leaderboard at the following weights based on the games you are playing. This helps prevent leaderboard abuse:
            </div>
            <ol class="list-disc mt-4 ml-5">
              <li>Games with an RTP of 97% or less will contribute 100% of the amount wagered to the leaderboard.</li>
              <li>Games with an RTP above 97% will contribute 50% of the amount wagered to the leaderboard.</li>
              <li>Games with an RTP of 98% and above will contribute 10% of theamount wagered to the leaderboard.</li>
              <li>Only house games and slots count towards leaderboard.</li>
            </ol>
          </div> -->
          </div>
        </div>
      </section>
    </div>
    <div class="lg:mb-96"></div>
  </section>

  <!-- Videos Section -->
  <section
    class="h-auto px-6 md:px-6 lg:px-36 2xl:px-[340px] py-20 lg:py-20 video-bg"
    id="videos"
  >
    <div class="flex flex-col justify-center items-center">
      <div class="flex flex-col md:flex-row items-center gap-6 font-nunito">
        <img src="../assets/roobet-logo.png" />
        <p class="text-white text-3xl font-bold uppercase tracking-wider">Videos</p>
      </div>
      <div class="flex flex-wrap justify-center gap-10 mt-16 font-nunito">
        <div class="flex flex-row items-center gap-2 uppercase">
          <img src="../assets/check.png" />
          <span class="text-white">Instant Rakeback</span>
        </div>
        <div class="flex flex-row items-center gap-2 uppercase">
          <img src="../assets/check.png" />
          <span class="text-white">Bi-Weekly Wager Race</span>
        </div>
        <div class="flex flex-row items-center gap-2 uppercase">
          <img src="../assets/check.png" />
          <span class="text-white">Bi-Weekly Raffle</span>
        </div>
        <div class="flex flex-row items-center gap-2 uppercase">
          <img src="../assets/check.png" />
          <span class="text-white">Exclusive Giveaways</span>
        </div>
      </div>
      <div class="flex flex-wrap bg-black rounded-2xl mt-16 font-nunito justify-center">
        <a href="https://www.youtube.com/watch?v=dpFI7QuqUDI&t=7s" target="_blank">
          <div
            v-motion-pop-visible
            class="flex flex-col justify-center items-center p-4 w-full md:w-[300px] gap-4"
          >
            <img
              src="../assets/thumbnails/thumbnails1.webp"
              class="rounded-xl w-full md:w-[280px]"
              alt="thumbnail1"
            />
            <p class="text-white text-base text-center md:text-left w-[260px] font-bold">
              I HIT HUGE ON 5 LIONS! (INSANE)
            </p>
            <p class="text-[#AAC2E6] uppercase flex text-xs">Click to view</p>
          </div>
        </a>
        <a href="https://www.youtube.com/watch?v=odjpYrKzXgQ" target="_blank">
          <div
            v-motion-pop-visible
            class="flex flex-col justify-ced items-center p-4 w-full md:w-[300px] gap-4"
          >
            <img
              src="../assets/thumbnails/thumbnails2.webp"
              class="rounded-xl w-full md:w-[280px]"
              alt="thumbnail1"
            />
            <p class="text-white text-sm text-center md:text-left w-[260px] font-bold">
              STAR BOUNTY Saved the Day – Huge Comeback!🎰
            </p>
            <p class="text-[#AAC2E6] uppercase text-xs">Click to view</p>
          </div>
        </a>
        <!-- <a
          href="https://www.youtube.com/watch?v=KpsbYMWM374&pp=0gcJCXcA-SJGOe9V"
          target="_blank"
        >
          <div
            v-motion-pop-visible
            class="flex flex-col justify-ced items-center p-4 w-full md:w-[300px] gap-4"
          >
            <img
              src="../assets/thumbnails/thumbnails3.webp"
              class="rounded-xl w-full md:w-[280px]"
              alt="thumbnail1"
            />
            <p class="text-white text-sm text-center md:text-left w-[260px] font-bold">
              THAT'S WHY I LOVE CHICKEN.GG! 🐔💰 (HUGE PULLS)
            </p>
            <p class="text-[#AAC2E6] uppercase text-xs">Click to view</p>
          </div>
        </a> -->
      </div>
      <div class="mt-10 font-nunito">
        <a href="https://www.youtube.com/@MrChocolateslots" target="_blank">
          <button
            class="text-black font-bold bg-gradient-to-br from-white via-red-100 to-white font-base py-5 px-[30px] relative uppercase rounded-xl transition hover:scale-105 ease-in-out duration-200"
          >
            Visit Youtube Channel
          </button>
        </a>
      </div>
    </div>
  </section>
  <section
    class="h-auto px-6 md:px-6 lg:px-36 2xl:px-[340px] py-20 lg:py-20"
    id="vip-transfer"
  >
    <div
      class="bg-black border border-[#A26446] text-white p-8 rounded-lg shadow-lg font-nunito"
    >
      <h2 class="text-center text-2xl md:text-3xl font-bold mb-6">VIP TRANSFER</h2>

      <div class="space-y-6">
        <div>
          <h3 class="text-lg font-semibold">WHAT ARE VIP TRANSFERS?</h3>
          <p class="text-gray-300 ml-0 lg:ml-8 uppercase">
            VIP transfer is a term commonly used in the realm of gambling websites like
            Roobet. It refers to a process where users are granted special privileges or
            bonuses upon becoming VIP players.
          </p>
        </div>
        <div>
          <h3 class="text-lg font-semibold">HOW DO VIP TRANSFERS TO ROOBET WORK?</h3>
          <p class="text-gray-300 ml-0 lg:ml-8 uppercase">
            Play on Roobet and over a 3-week period of enjoying Roobet’s generous bonuses,
            Roobet evaluates players for potential VIP status based on their activity and
            engagement. If deemed worthy, selected users will receive personal contact
            from a VIP manager, who will provide details about Roobet’s VIP program and
            extend an invitation to join.
          </p>
        </div>

        <div>
          <h3 class="text-lg font-semibold">WHAT ARE THE REQUIREMENTS?</h3>
          <ul class="list-none list-inside text-gray-300 ml-0 lg:ml-8 uppercase">
            <li>
              You must have a Roobet account under code
              <strong>"**MRCHOCOLATE**"</strong>.
            </li>
            <li>You must have VIP on another valid gambling website.</li>
          </ul>
        </div>

        <div>
          <h3 class="text-lg font-semibold">
            WHAT’S THE PURPOSE OF TRANSFERRING MY VIP STATUS TO ROOBET?
          </h3>
          <p class="text-gray-300 ml-0 lg:ml-8 uppercase">
            Roobet provides amazing bonuses starting within your first 3 weeks of play and
            then continuing to progress. Once getting into VIP, you can compete in the
            <strong>"**MRCHOCOLATE**"</strong> Roobet leaderboard every month.
          </p>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-white">
            ROOBET PROVIDES THE BEST REWARDS IN THE LONG RUN
          </h3>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import moment from "moment-timezone";

export default {
  name: "LeaderboardSection",
  data() {
    return {
      leaderboardData: {},
      leaderboardPrevData: {},
      top3: [],
      top10: [],
      top13: [],
      timer: "0d 0h 0m 0s",
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      totalPrize: 0,
      currentLeaderboard: "roobet",
      previousLeaderboard: false,
      startDate: null,
      endDate: null,
      notFormattedEndDate: null,
      loading: false,
      timerInterval: null,
    };
  },
  watch: {
    previousLeaderboard() {
      this.changeLeaderboard();
      this.startTimer();
    },
    currentLeaderboard() {
      this.fetchLeaderboard();
    },
  },
  methods: {
    async fetchLeaderboard() {
      this.loading = true;
      this.leaderboardData = {};
      this.leaderboardPrevData = {};
      this.top3 = [];
      this.top10 = [];
      this.top13 = [];

      const baseUrl = process.env.VUE_APP_BASE_API;
      const apiKey = process.env.VUE_APP_X_API_KEY;

      try {
        const res = await axios.get(
          `${baseUrl}/api/leaderboard/${this.currentLeaderboard}`,
          {
            headers: {
              "x-api-key": apiKey,
            },
          }
        );
        this.leaderboardData = this.normalizeLeaderboardData(res.data);
        this.startDate = moment(res.data.startDate).format("MMMM DD, YYYY");
        this.endDate = moment(res.data.endDate).format("MMMM DD, YYYY");
        this.notFormattedEndDate = res.data.endDate;

        if (this.shouldFetchPreviousLeaderboard()) {
          const prevRes = await axios.get(
            `${baseUrl}/api/leaderboard/${this.currentLeaderboard}?previous=true`,
            {
              headers: {
                "x-api-key": apiKey,
              },
            }
          );
          this.leaderboardPrevData = this.normalizeLeaderboardData(prevRes.data);
        }

        this.changeLeaderboard();
        this.startTimer();
      } catch (e) {
        console.error("Leaderboard fetch error", e);
      } finally {
        this.loading = false;
      }
    },

    normalizeLeaderboardData(data) {
      if (!data || !data.leaderboard) return { leaderboard: [] };
      return {
        startDate: data.startDate,
        endDate: data.endDate,
        leaderboard: data.leaderboard.map((entry) => ({
          username: this.getUsername(entry),
          wagered: this.formatCurrency(this.getWageredAmount(entry)),
        })),
      };
    },

    getUsername(entry) {
      return entry.username || "";
    },

    getWageredAmount(entry) {
      switch (this.currentLeaderboard) {
        case "roobet":
          return entry.weightedWagered || 0;
        case "raingg":
          return entry.wagered || 0;
        case "packdraw":
          return entry.wagerAmount || 0;
        default:
          return 0;
      }
    },

    shouldFetchPreviousLeaderboard() {
      const key = `VUE_APP_SHOW_PREVIOUS_LEADERBOARD_${this.currentLeaderboard.toUpperCase()}`;
      return process.env[key] === "true";
    },

    formatCurrency(amount) {
      if (typeof amount !== "number") return "---";
      return amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    changeLeaderboard() {
      const data = this.previousLeaderboard
        ? this.leaderboardPrevData.leaderboard
        : this.leaderboardData.leaderboard;

      this.top3 = data.slice(0, 3);
      this.top10 = data.slice(3, 10);
      this.top13 = data.slice(0, 10);
      this.notFormattedEndDate = this.previousLeaderboard
        ? this.leaderboardPrevData.endDate
        : this.leaderboardData.endDate;

      const key = `VUE_APP_${this.currentLeaderboard.toUpperCase()}_${
        this.previousLeaderboard ? "PREVIOUS" : "CURRENT"
      }_LEADERBOARD_REWARDS`;

      const rewards = JSON.parse(process.env[key] || "[]");
      this.totalPrize = rewards.reduce((sum, val) => sum + Number(val || 0), 0);
    },

    getRewardValue(rank) {
      const key = `VUE_APP_${this.currentLeaderboard.toUpperCase()}_${
        this.previousLeaderboard ? "PREVIOUS" : "CURRENT"
      }_LEADERBOARD_REWARDS`;
      const rewards = JSON.parse(process.env[key] || "[]");

      if (rank >= rewards.length || rewards[rank] === undefined) {
        return "---";
      }

      const val = rewards[rank];
      return this.currentLeaderboard === "raingg" ? `${val}c` : `$${val}`;
    },

    getFormattedTotalPrize() {
      if (!this.totalPrize) return "$0";

      const formatted = this.totalPrize.toLocaleString();

      return this.currentLeaderboard === "raingg" ? `${formatted}c` : `$${formatted}`;
    },
    maskString(str) {
      if (!str || str.length < 2) return str;
      const first = str[0],
        last = str[str.length - 1];
      return `${first}${"*".repeat(str.length - 2)}${last}`;
    },

    getOrdinalSuffix(n) {
      const s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },

    startTimer() {
      if (!this.notFormattedEndDate) return;
      clearInterval(this.timerInterval);

      const periodKey = `VUE_APP_${this.currentLeaderboard.toUpperCase()}_TIMER_PERIOD`;
      const period = process.env[periodKey] || "week";

      const getNextTargetDate = () => {
        const now = moment().tz("America/New_York");
        let target = moment
          .utc(this.notFormattedEndDate)
          .tz("America/New_York")
          .subtract(1, "second");

        if (now.isAfter(target)) {
          if (period === "week") target.add(1, "week");
          else if (period === "month") target.add(1, "month");
          else if (period === "custom") {
            const days = parseInt(
              process.env[`${this.currentLeaderboard.toUpperCase()}_CUSTOM_DAYS`] || "7",
              10
            );
            target.add(days, "days");
          }
        }

        return target;
      };

      let targetDate = getNextTargetDate();

      const update = () => {
        const now = moment().tz("America/New_York");
        const diff = targetDate.diff(now);

        if (diff < 0) {
          clearInterval(this.timerInterval);
          this.days = this.hours = this.minutes = this.seconds = 0;
          return;
        }

        const dur = moment.duration(diff);
        this.days = Math.floor(dur.asDays());
        this.hours = dur.hours();
        this.minutes = dur.minutes();
        this.seconds = dur.seconds();
      };

      update();
      this.timerInterval = setInterval(update, 1000);
    },
  },
  mounted() {
    this.fetchLeaderboard();
  },
};
</script>

<style scope>
.main-btn:hover .main-span {
  border-color: #1294f0;
}

.leaderboard-bg {
  background-image: url("../assets/leaderboard-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
}

.socials-bg {
  background-image: url("../assets/socials-bg.png");
  background-repeat: no-repeat;
  background-position: bottom left;
}

.promotion-frame-bg {
  background-image: url("../assets/promotion-frame-bg.png");
  background-repeat: no-repeat;
  background-size: contain;
}

.promotion-frame-mobile-bg {
  background-image: url("../assets/promotion-frame-mobile-bg.png");
  background-repeat: no-repeat;
  background-size: contain;
}

.hero-bg {
  background-image: url("../assets/main-page-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom right;
}

.video-bg {
  background-image: url("../assets/video-bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
